<template>
    <div class="page">
      <SiteHero
        pageTitle="Buena Park"
        pageDescription=""
      />
    
      <div class="page-content">
        <div class="max-w-6xl mx-auto px-4 py-12">
          <div class="grid grid-cols-1 gap-8">
            <div id="schedule" class="location-block scroll-mt-32">
              <div class="grid grid-cols-1 gap-8">
                <LocationTitle title="BUENA PARK SCHEDULE" />
                <hr />
              </div>
              <ScheduleCategory 
                title="BUENA PARK CLASSES"
                id="buenaParkSchedule"
                scheduleType="uncategorized"
                location="buenaPark"
              />
            </div>
          </div>
        </div>

        <div class="max-w-6xl mx-auto px-4 py-12">
          <div class="grid grid-cols-1 gap-8">
            <div v-for="location in filteredLocations" :key="location.name">
              <TrainingGround :location="location" />
            </div>
          </div>
        </div>
      </div>
  
      <SiteFooter />
    </div>
  </template>
      
  <script>
  import LocationTitle from '../components/Schedule/LocationTitle.vue'
  import ScheduleCategory from '../components/Schedule/ScheduleCategory.vue'
  import SiteFooter from '../components/Footer/SiteFooter.vue'
  import SiteHero from '../components/Hero/SiteHero.vue'
  import TrainingGround from '../components/Location/TrainingGround.vue'
  import locationsData from '../data/locations.json'
  import '../assets/styles/page.css'
    
  export default {
    name: 'LocationsBuenaPark',
    components: {
      LocationTitle,
      ScheduleCategory,
      SiteFooter,
      SiteHero,
      TrainingGround
    },
    computed: {
      filteredLocations() {
        return locationsData.locations.filter(location => location.locationUrl === 'buena-park')
      }
    }
  }
  </script>
  